/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as msRest from "@azure/ms-rest-js";
import * as Models from "./models";
import * as Mappers from "./models/mappers";
import * as Parameters from "./models/parameters";
import { KamigamePreRegistrationApiContext } from "./kamigamePreRegistrationApiContext";

class KamigamePreRegistrationApi extends KamigamePreRegistrationApiContext {
  /**
   * Initializes a new instance of the KamigamePreRegistrationApi class.
   * @param credentials Subscription credentials which uniquely identify client subscription.
   * @param [options] The parameter options
   */
  constructor(credentials: msRest.ServiceClientCredentials, options?: Models.KamigamePreRegistrationApiOptions) {
    super(credentials, options);
  }

  /**
   * 有効なガチャの一覧を取得します
   * @param [options] The optional parameters
   * @returns Promise<Models.ListActiveGachaResponse>
   */
  listActiveGacha(options?: msRest.RequestOptionsBase): Promise<Models.ListActiveGachaResponse>;
  /**
   * @param callback The callback
   */
  listActiveGacha(callback: msRest.ServiceCallback<Models.Gacha[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  listActiveGacha(options: msRest.RequestOptionsBase, callback: msRest.ServiceCallback<Models.Gacha[]>): void;
  listActiveGacha(options?: msRest.RequestOptionsBase | msRest.ServiceCallback<Models.Gacha[]>, callback?: msRest.ServiceCallback<Models.Gacha[]>): Promise<Models.ListActiveGachaResponse> {
    return this.sendOperationRequest(
      {
        options
      },
      listActiveGachaOperationSpec,
      callback) as Promise<Models.ListActiveGachaResponse>;
  }

  /**
   * ログインのリクエストです
   * @param [options] The optional parameters
   * @returns Promise<Models.LoginResponse>
   */
  login(options?: Models.KamigamePreRegistrationApiLoginOptionalParams): Promise<Models.LoginResponse>;
  /**
   * @param callback The callback
   */
  login(callback: msRest.ServiceCallback<Models.Session>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  login(options: Models.KamigamePreRegistrationApiLoginOptionalParams, callback: msRest.ServiceCallback<Models.Session>): void;
  login(options?: Models.KamigamePreRegistrationApiLoginOptionalParams | msRest.ServiceCallback<Models.Session>, callback?: msRest.ServiceCallback<Models.Session>): Promise<Models.LoginResponse> {
    return this.sendOperationRequest(
      {
        options
      },
      loginOperationSpec,
      callback) as Promise<Models.LoginResponse>;
  }

  /**
   * 複数のギフトコードを作成します
   * @param gachaId
   * @param [options] The optional parameters
   * @returns Promise<Models.CreateGiftCodeBulkResponse>
   */
  createGiftCodeBulk(gachaId: string, options?: Models.KamigamePreRegistrationApiCreateGiftCodeBulkOptionalParams): Promise<Models.CreateGiftCodeBulkResponse>;
  /**
   * @param gachaId
   * @param callback The callback
   */
  createGiftCodeBulk(gachaId: string, callback: msRest.ServiceCallback<Models.GiftCode[]>): void;
  /**
   * @param gachaId
   * @param options The optional parameters
   * @param callback The callback
   */
  createGiftCodeBulk(gachaId: string, options: Models.KamigamePreRegistrationApiCreateGiftCodeBulkOptionalParams, callback: msRest.ServiceCallback<Models.GiftCode[]>): void;
  createGiftCodeBulk(gachaId: string, options?: Models.KamigamePreRegistrationApiCreateGiftCodeBulkOptionalParams | msRest.ServiceCallback<Models.GiftCode[]>, callback?: msRest.ServiceCallback<Models.GiftCode[]>): Promise<Models.CreateGiftCodeBulkResponse> {
    return this.sendOperationRequest(
      {
        gachaId,
        options
      },
      createGiftCodeBulkOperationSpec,
      callback) as Promise<Models.CreateGiftCodeBulkResponse>;
  }

  /**
   * ギフトコードの一覧を取得します
   * @summary Your GET endpoint
   * @param gachaId
   * @param [options] The optional parameters
   * @returns Promise<Models.ListGiftCodeResponse>
   */
  listGiftCode(gachaId: string, options?: msRest.RequestOptionsBase): Promise<Models.ListGiftCodeResponse>;
  /**
   * @param gachaId
   * @param callback The callback
   */
  listGiftCode(gachaId: string, callback: msRest.ServiceCallback<Models.GiftCode[]>): void;
  /**
   * @param gachaId
   * @param options The optional parameters
   * @param callback The callback
   */
  listGiftCode(gachaId: string, options: msRest.RequestOptionsBase, callback: msRest.ServiceCallback<Models.GiftCode[]>): void;
  listGiftCode(gachaId: string, options?: msRest.RequestOptionsBase | msRest.ServiceCallback<Models.GiftCode[]>, callback?: msRest.ServiceCallback<Models.GiftCode[]>): Promise<Models.ListGiftCodeResponse> {
    return this.sendOperationRequest(
      {
        gachaId,
        options
      },
      listGiftCodeOperationSpec,
      callback) as Promise<Models.ListGiftCodeResponse>;
  }

  /**
   * ガチャを作成します
   * @param [options] The optional parameters
   * @returns Promise<Models.CreateGachaResponse>
   */
  createGacha(options?: Models.KamigamePreRegistrationApiCreateGachaOptionalParams): Promise<Models.CreateGachaResponse>;
  /**
   * @param callback The callback
   */
  createGacha(callback: msRest.ServiceCallback<Models.Gacha>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  createGacha(options: Models.KamigamePreRegistrationApiCreateGachaOptionalParams, callback: msRest.ServiceCallback<Models.Gacha>): void;
  createGacha(options?: Models.KamigamePreRegistrationApiCreateGachaOptionalParams | msRest.ServiceCallback<Models.Gacha>, callback?: msRest.ServiceCallback<Models.Gacha>): Promise<Models.CreateGachaResponse> {
    return this.sendOperationRequest(
      {
        options
      },
      createGachaOperationSpec,
      callback) as Promise<Models.CreateGachaResponse>;
  }

  /**
   * ガチャの一覧を取得します
   * @param [options] The optional parameters
   * @returns Promise<Models.ListGachaResponse>
   */
  listGacha(options?: msRest.RequestOptionsBase): Promise<Models.ListGachaResponse>;
  /**
   * @param callback The callback
   */
  listGacha(callback: msRest.ServiceCallback<Models.Gacha[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  listGacha(options: msRest.RequestOptionsBase, callback: msRest.ServiceCallback<Models.Gacha[]>): void;
  listGacha(options?: msRest.RequestOptionsBase | msRest.ServiceCallback<Models.Gacha[]>, callback?: msRest.ServiceCallback<Models.Gacha[]>): Promise<Models.ListGachaResponse> {
    return this.sendOperationRequest(
      {
        options
      },
      listGachaOperationSpec,
      callback) as Promise<Models.ListGachaResponse>;
  }

  /**
   * ガチャを更新します
   * @param gachaId
   * @param [options] The optional parameters
   * @returns Promise<msRest.RestResponse>
   */
  updateGacha(gachaId: string, options?: Models.KamigamePreRegistrationApiUpdateGachaOptionalParams): Promise<msRest.RestResponse>;
  /**
   * @param gachaId
   * @param callback The callback
   */
  updateGacha(gachaId: string, callback: msRest.ServiceCallback<void>): void;
  /**
   * @param gachaId
   * @param options The optional parameters
   * @param callback The callback
   */
  updateGacha(gachaId: string, options: Models.KamigamePreRegistrationApiUpdateGachaOptionalParams, callback: msRest.ServiceCallback<void>): void;
  updateGacha(gachaId: string, options?: Models.KamigamePreRegistrationApiUpdateGachaOptionalParams | msRest.ServiceCallback<void>, callback?: msRest.ServiceCallback<void>): Promise<msRest.RestResponse> {
    return this.sendOperationRequest(
      {
        gachaId,
        options
      },
      updateGachaOperationSpec,
      callback);
  }

  /**
   * ガチャを取得します
   * @param gachaId
   * @param [options] The optional parameters
   * @returns Promise<Models.FindGachaResponse>
   */
  findGacha(gachaId: string, options?: msRest.RequestOptionsBase): Promise<Models.FindGachaResponse>;
  /**
   * @param gachaId
   * @param callback The callback
   */
  findGacha(gachaId: string, callback: msRest.ServiceCallback<Models.Gacha>): void;
  /**
   * @param gachaId
   * @param options The optional parameters
   * @param callback The callback
   */
  findGacha(gachaId: string, options: msRest.RequestOptionsBase, callback: msRest.ServiceCallback<Models.Gacha>): void;
  findGacha(gachaId: string, options?: msRest.RequestOptionsBase | msRest.ServiceCallback<Models.Gacha>, callback?: msRest.ServiceCallback<Models.Gacha>): Promise<Models.FindGachaResponse> {
    return this.sendOperationRequest(
      {
        gachaId,
        options
      },
      findGachaOperationSpec,
      callback) as Promise<Models.FindGachaResponse>;
  }

  /**
   * ガチャに挑戦します
   * @param gachaId
   * @param [options] The optional parameters
   * @returns Promise<Models.PlayGachaResponse2>
   */
  playGacha(gachaId: string, options?: Models.KamigamePreRegistrationApiPlayGachaOptionalParams): Promise<Models.PlayGachaResponse2>;
  /**
   * @param gachaId
   * @param callback The callback
   */
  playGacha(gachaId: string, callback: msRest.ServiceCallback<Models.PlayGachaResponse>): void;
  /**
   * @param gachaId
   * @param options The optional parameters
   * @param callback The callback
   */
  playGacha(gachaId: string, options: Models.KamigamePreRegistrationApiPlayGachaOptionalParams, callback: msRest.ServiceCallback<Models.PlayGachaResponse>): void;
  playGacha(gachaId: string, options?: Models.KamigamePreRegistrationApiPlayGachaOptionalParams | msRest.ServiceCallback<Models.PlayGachaResponse>, callback?: msRest.ServiceCallback<Models.PlayGachaResponse>): Promise<Models.PlayGachaResponse2> {
    return this.sendOperationRequest(
      {
        gachaId,
        options
      },
      playGachaOperationSpec,
      callback) as Promise<Models.PlayGachaResponse2>;
  }

  /**
   * SMS 認証用のコードと id をリクエストします
   * @param [options] The optional parameters
   * @returns Promise<Models.GenerateSmsAuthCodeResponse>
   */
  generateSmsAuthCode(options?: Models.KamigamePreRegistrationApiGenerateSmsAuthCodeOptionalParams): Promise<Models.GenerateSmsAuthCodeResponse>;
  /**
   * @param callback The callback
   */
  generateSmsAuthCode(callback: msRest.ServiceCallback<Models.GenerateSmsAuthIdResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  generateSmsAuthCode(options: Models.KamigamePreRegistrationApiGenerateSmsAuthCodeOptionalParams, callback: msRest.ServiceCallback<Models.GenerateSmsAuthIdResponse>): void;
  generateSmsAuthCode(options?: Models.KamigamePreRegistrationApiGenerateSmsAuthCodeOptionalParams | msRest.ServiceCallback<Models.GenerateSmsAuthIdResponse>, callback?: msRest.ServiceCallback<Models.GenerateSmsAuthIdResponse>): Promise<Models.GenerateSmsAuthCodeResponse> {
    return this.sendOperationRequest(
      {
        options
      },
      generateSmsAuthCodeOperationSpec,
      callback) as Promise<Models.GenerateSmsAuthCodeResponse>;
  }

  /**
   * SMS 認証のコードを検証します
   * @param [options] The optional parameters
   * @returns Promise<msRest.RestResponse>
   */
  verifySmsAuthCode(options?: Models.KamigamePreRegistrationApiVerifySmsAuthCodeOptionalParams): Promise<msRest.RestResponse>;
  /**
   * @param callback The callback
   */
  verifySmsAuthCode(callback: msRest.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  verifySmsAuthCode(options: Models.KamigamePreRegistrationApiVerifySmsAuthCodeOptionalParams, callback: msRest.ServiceCallback<void>): void;
  verifySmsAuthCode(options?: Models.KamigamePreRegistrationApiVerifySmsAuthCodeOptionalParams | msRest.ServiceCallback<void>, callback?: msRest.ServiceCallback<void>): Promise<msRest.RestResponse> {
    return this.sendOperationRequest(
      {
        options
      },
      verifySmsAuthCodeOperationSpec,
      callback);
  }

  /**
   * オプトアウトの設定を変更します
   * @param [options] The optional parameters
   * @returns Promise<msRest.RestResponse>
   */
  updateUserOptout(options?: Models.KamigamePreRegistrationApiUpdateUserOptoutOptionalParams): Promise<msRest.RestResponse>;
  /**
   * @param callback The callback
   */
  updateUserOptout(callback: msRest.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  updateUserOptout(options: Models.KamigamePreRegistrationApiUpdateUserOptoutOptionalParams, callback: msRest.ServiceCallback<void>): void;
  updateUserOptout(options?: Models.KamigamePreRegistrationApiUpdateUserOptoutOptionalParams | msRest.ServiceCallback<void>, callback?: msRest.ServiceCallback<void>): Promise<msRest.RestResponse> {
    return this.sendOperationRequest(
      {
        options
      },
      updateUserOptoutOperationSpec,
      callback);
  }

  /**
   * 当選者情報の一覧を取得します
   * @summary Your GET endpoint
   * @param gachaId
   * @param [options] The optional parameters
   * @returns Promise<Models.ListGachaWinningResponse2>
   */
  listGachaWinning(gachaId: string, options?: Models.KamigamePreRegistrationApiListGachaWinningOptionalParams): Promise<Models.ListGachaWinningResponse2>;
  /**
   * @param gachaId
   * @param callback The callback
   */
  listGachaWinning(gachaId: string, callback: msRest.ServiceCallback<Models.ListGachaWinningResponse>): void;
  /**
   * @param gachaId
   * @param options The optional parameters
   * @param callback The callback
   */
  listGachaWinning(gachaId: string, options: Models.KamigamePreRegistrationApiListGachaWinningOptionalParams, callback: msRest.ServiceCallback<Models.ListGachaWinningResponse>): void;
  listGachaWinning(gachaId: string, options?: Models.KamigamePreRegistrationApiListGachaWinningOptionalParams | msRest.ServiceCallback<Models.ListGachaWinningResponse>, callback?: msRest.ServiceCallback<Models.ListGachaWinningResponse>): Promise<Models.ListGachaWinningResponse2> {
    return this.sendOperationRequest(
      {
        gachaId,
        options
      },
      listGachaWinningOperationSpec,
      callback) as Promise<Models.ListGachaWinningResponse2>;
  }

  /**
   * 当選者のステータスを更新します
   * @param gachaId
   * @param winningId
   * @param [options] The optional parameters
   * @returns Promise<msRest.RestResponse>
   */
  updateGachaWinningStatus(gachaId: string, winningId: string, options?: Models.KamigamePreRegistrationApiUpdateGachaWinningStatusOptionalParams): Promise<msRest.RestResponse>;
  /**
   * @param gachaId
   * @param winningId
   * @param callback The callback
   */
  updateGachaWinningStatus(gachaId: string, winningId: string, callback: msRest.ServiceCallback<void>): void;
  /**
   * @param gachaId
   * @param winningId
   * @param options The optional parameters
   * @param callback The callback
   */
  updateGachaWinningStatus(gachaId: string, winningId: string, options: Models.KamigamePreRegistrationApiUpdateGachaWinningStatusOptionalParams, callback: msRest.ServiceCallback<void>): void;
  updateGachaWinningStatus(gachaId: string, winningId: string, options?: Models.KamigamePreRegistrationApiUpdateGachaWinningStatusOptionalParams | msRest.ServiceCallback<void>, callback?: msRest.ServiceCallback<void>): Promise<msRest.RestResponse> {
    return this.sendOperationRequest(
      {
        gachaId,
        winningId,
        options
      },
      updateGachaWinningStatusOperationSpec,
      callback);
  }

  /**
   * ログインしているユーザの情報を取得します
   * @summary Your GET endpoint
   * @param [options] The optional parameters
   * @returns Promise<Models.GetMeResponse>
   */
  getMe(options?: msRest.RequestOptionsBase): Promise<Models.GetMeResponse>;
  /**
   * @param callback The callback
   */
  getMe(callback: msRest.ServiceCallback<Models.User>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getMe(options: msRest.RequestOptionsBase, callback: msRest.ServiceCallback<Models.User>): void;
  getMe(options?: msRest.RequestOptionsBase | msRest.ServiceCallback<Models.User>, callback?: msRest.ServiceCallback<Models.User>): Promise<Models.GetMeResponse> {
    return this.sendOperationRequest(
      {
        options
      },
      getMeOperationSpec,
      callback) as Promise<Models.GetMeResponse>;
  }

  /**
   * ユーザのオプトインの情報を更新します
   * @param [options] The optional parameters
   * @returns Promise<Models.UpdateUserOptinResponse>
   */
  updateUserOptin(options?: Models.KamigamePreRegistrationApiUpdateUserOptinOptionalParams): Promise<Models.UpdateUserOptinResponse>;
  /**
   * @param callback The callback
   */
  updateUserOptin(callback: msRest.ServiceCallback<any>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  updateUserOptin(options: Models.KamigamePreRegistrationApiUpdateUserOptinOptionalParams, callback: msRest.ServiceCallback<any>): void;
  updateUserOptin(options?: Models.KamigamePreRegistrationApiUpdateUserOptinOptionalParams | msRest.ServiceCallback<any>, callback?: msRest.ServiceCallback<any>): Promise<Models.UpdateUserOptinResponse> {
    return this.sendOperationRequest(
      {
        options
      },
      updateUserOptinOperationSpec,
      callback) as Promise<Models.UpdateUserOptinResponse>;
  }

  /**
   * メール到達確認をします
   * @param [options] The optional parameters
   * @returns Promise<msRest.RestResponse>
   */
  verifyEmailAddress(options?: Models.KamigamePreRegistrationApiVerifyEmailAddressOptionalParams): Promise<msRest.RestResponse>;
  /**
   * @param callback The callback
   */
  verifyEmailAddress(callback: msRest.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  verifyEmailAddress(options: Models.KamigamePreRegistrationApiVerifyEmailAddressOptionalParams, callback: msRest.ServiceCallback<void>): void;
  verifyEmailAddress(options?: Models.KamigamePreRegistrationApiVerifyEmailAddressOptionalParams | msRest.ServiceCallback<void>, callback?: msRest.ServiceCallback<void>): Promise<msRest.RestResponse> {
    return this.sendOperationRequest(
      {
        options
      },
      verifyEmailAddressOperationSpec,
      callback);
  }

  /**
   * メール認証のための情報を作成します
   * @param [options] The optional parameters
   * @returns Promise<msRest.RestResponse>
   */
  createEmailVerification(options?: msRest.RequestOptionsBase): Promise<msRest.RestResponse>;
  /**
   * @param callback The callback
   */
  createEmailVerification(callback: msRest.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  createEmailVerification(options: msRest.RequestOptionsBase, callback: msRest.ServiceCallback<void>): void;
  createEmailVerification(options?: msRest.RequestOptionsBase | msRest.ServiceCallback<void>, callback?: msRest.ServiceCallback<void>): Promise<msRest.RestResponse> {
    return this.sendOperationRequest(
      {
        options
      },
      createEmailVerificationOperationSpec,
      callback);
  }

  /**
   * ガチャごとの事前登録者一覧を取得します
   * @summary Your GET endpoint
   * @param gachaId
   * @param [options] The optional parameters
   * @returns Promise<Models.ListGachaRegisterPerGameResponse>
   */
  listGachaRegisterPerGame(gachaId: string, options?: Models.KamigamePreRegistrationApiListGachaRegisterPerGameOptionalParams): Promise<Models.ListGachaRegisterPerGameResponse>;
  /**
   * @param gachaId
   * @param callback The callback
   */
  listGachaRegisterPerGame(gachaId: string, callback: msRest.ServiceCallback<Models.ListGachaRegisterResponse>): void;
  /**
   * @param gachaId
   * @param options The optional parameters
   * @param callback The callback
   */
  listGachaRegisterPerGame(gachaId: string, options: Models.KamigamePreRegistrationApiListGachaRegisterPerGameOptionalParams, callback: msRest.ServiceCallback<Models.ListGachaRegisterResponse>): void;
  listGachaRegisterPerGame(gachaId: string, options?: Models.KamigamePreRegistrationApiListGachaRegisterPerGameOptionalParams | msRest.ServiceCallback<Models.ListGachaRegisterResponse>, callback?: msRest.ServiceCallback<Models.ListGachaRegisterResponse>): Promise<Models.ListGachaRegisterPerGameResponse> {
    return this.sendOperationRequest(
      {
        gachaId,
        options
      },
      listGachaRegisterPerGameOperationSpec,
      callback) as Promise<Models.ListGachaRegisterPerGameResponse>;
  }

  /**
   * 当選者を承認します
   * @param gachaId
   * @param [options] The optional parameters
   * @returns Promise<Models.ApproveGachaWinningResponse2>
   */
  approveGachaWinning(gachaId: string, options?: Models.KamigamePreRegistrationApiApproveGachaWinningOptionalParams): Promise<Models.ApproveGachaWinningResponse2>;
  /**
   * @param gachaId
   * @param callback The callback
   */
  approveGachaWinning(gachaId: string, callback: msRest.ServiceCallback<Models.ApproveGachaWinningResponse>): void;
  /**
   * @param gachaId
   * @param options The optional parameters
   * @param callback The callback
   */
  approveGachaWinning(gachaId: string, options: Models.KamigamePreRegistrationApiApproveGachaWinningOptionalParams, callback: msRest.ServiceCallback<Models.ApproveGachaWinningResponse>): void;
  approveGachaWinning(gachaId: string, options?: Models.KamigamePreRegistrationApiApproveGachaWinningOptionalParams | msRest.ServiceCallback<Models.ApproveGachaWinningResponse>, callback?: msRest.ServiceCallback<Models.ApproveGachaWinningResponse>): Promise<Models.ApproveGachaWinningResponse2> {
    return this.sendOperationRequest(
      {
        gachaId,
        options
      },
      approveGachaWinningOperationSpec,
      callback) as Promise<Models.ApproveGachaWinningResponse2>;
  }

  /**
   * ガチャのリリース時のメールテンプレートを取得します
   * @summary Your GET endpoint
   * @param gachaId
   * @param [options] The optional parameters
   * @returns Promise<Models.FindReleaseEmailTemplateResponse>
   */
  findReleaseEmailTemplate(gachaId: string, options?: msRest.RequestOptionsBase): Promise<Models.FindReleaseEmailTemplateResponse>;
  /**
   * @param gachaId
   * @param callback The callback
   */
  findReleaseEmailTemplate(gachaId: string, callback: msRest.ServiceCallback<Models.EmailTemplate>): void;
  /**
   * @param gachaId
   * @param options The optional parameters
   * @param callback The callback
   */
  findReleaseEmailTemplate(gachaId: string, options: msRest.RequestOptionsBase, callback: msRest.ServiceCallback<Models.EmailTemplate>): void;
  findReleaseEmailTemplate(gachaId: string, options?: msRest.RequestOptionsBase | msRest.ServiceCallback<Models.EmailTemplate>, callback?: msRest.ServiceCallback<Models.EmailTemplate>): Promise<Models.FindReleaseEmailTemplateResponse> {
    return this.sendOperationRequest(
      {
        gachaId,
        options
      },
      findReleaseEmailTemplateOperationSpec,
      callback) as Promise<Models.FindReleaseEmailTemplateResponse>;
  }

  /**
   * リリース時のメールのテンプレートを作成します
   * @param gachaId
   * @param [options] The optional parameters
   * @returns Promise<Models.EditReleaseEmailTemplateResponse>
   */
  editReleaseEmailTemplate(gachaId: string, options?: Models.KamigamePreRegistrationApiEditReleaseEmailTemplateOptionalParams): Promise<Models.EditReleaseEmailTemplateResponse>;
  /**
   * @param gachaId
   * @param callback The callback
   */
  editReleaseEmailTemplate(gachaId: string, callback: msRest.ServiceCallback<Models.EmailTemplate>): void;
  /**
   * @param gachaId
   * @param options The optional parameters
   * @param callback The callback
   */
  editReleaseEmailTemplate(gachaId: string, options: Models.KamigamePreRegistrationApiEditReleaseEmailTemplateOptionalParams, callback: msRest.ServiceCallback<Models.EmailTemplate>): void;
  editReleaseEmailTemplate(gachaId: string, options?: Models.KamigamePreRegistrationApiEditReleaseEmailTemplateOptionalParams | msRest.ServiceCallback<Models.EmailTemplate>, callback?: msRest.ServiceCallback<Models.EmailTemplate>): Promise<Models.EditReleaseEmailTemplateResponse> {
    return this.sendOperationRequest(
      {
        gachaId,
        options
      },
      editReleaseEmailTemplateOperationSpec,
      callback) as Promise<Models.EditReleaseEmailTemplateResponse>;
  }

  /**
   * 事前登録完了時のメールテンプレートを取得します
   * @summary Your GET endpoint
   * @param gachaId
   * @param [options] The optional parameters
   * @returns Promise<Models.FindRegistrationEmailTemplateResponse>
   */
  findRegistrationEmailTemplate(gachaId: string, options?: msRest.RequestOptionsBase): Promise<Models.FindRegistrationEmailTemplateResponse>;
  /**
   * @param gachaId
   * @param callback The callback
   */
  findRegistrationEmailTemplate(gachaId: string, callback: msRest.ServiceCallback<Models.EmailTemplate>): void;
  /**
   * @param gachaId
   * @param options The optional parameters
   * @param callback The callback
   */
  findRegistrationEmailTemplate(gachaId: string, options: msRest.RequestOptionsBase, callback: msRest.ServiceCallback<Models.EmailTemplate>): void;
  findRegistrationEmailTemplate(gachaId: string, options?: msRest.RequestOptionsBase | msRest.ServiceCallback<Models.EmailTemplate>, callback?: msRest.ServiceCallback<Models.EmailTemplate>): Promise<Models.FindRegistrationEmailTemplateResponse> {
    return this.sendOperationRequest(
      {
        gachaId,
        options
      },
      findRegistrationEmailTemplateOperationSpec,
      callback) as Promise<Models.FindRegistrationEmailTemplateResponse>;
  }

  /**
   * 事前登録完了時のメールテンプレートを作成します
   * @param gachaId
   * @param [options] The optional parameters
   * @returns Promise<Models.EditRegistrationEmailTemplateResponse>
   */
  editRegistrationEmailTemplate(gachaId: string, options?: Models.KamigamePreRegistrationApiEditRegistrationEmailTemplateOptionalParams): Promise<Models.EditRegistrationEmailTemplateResponse>;
  /**
   * @param gachaId
   * @param callback The callback
   */
  editRegistrationEmailTemplate(gachaId: string, callback: msRest.ServiceCallback<Models.EmailTemplate>): void;
  /**
   * @param gachaId
   * @param options The optional parameters
   * @param callback The callback
   */
  editRegistrationEmailTemplate(gachaId: string, options: Models.KamigamePreRegistrationApiEditRegistrationEmailTemplateOptionalParams, callback: msRest.ServiceCallback<Models.EmailTemplate>): void;
  editRegistrationEmailTemplate(gachaId: string, options?: Models.KamigamePreRegistrationApiEditRegistrationEmailTemplateOptionalParams | msRest.ServiceCallback<Models.EmailTemplate>, callback?: msRest.ServiceCallback<Models.EmailTemplate>): Promise<Models.EditRegistrationEmailTemplateResponse> {
    return this.sendOperationRequest(
      {
        gachaId,
        options
      },
      editRegistrationEmailTemplateOperationSpec,
      callback) as Promise<Models.EditRegistrationEmailTemplateResponse>;
  }

  /**
   * 自分の事前登録履歴を取得します
   * @summary Your GET endpoint
   * @param [options] The optional parameters
   * @returns Promise<Models.ListMyRegistrationResponse>
   */
  listMyRegistration(options?: Models.KamigamePreRegistrationApiListMyRegistrationOptionalParams): Promise<Models.ListMyRegistrationResponse>;
  /**
   * @param callback The callback
   */
  listMyRegistration(callback: msRest.ServiceCallback<Models.GachaRegister[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  listMyRegistration(options: Models.KamigamePreRegistrationApiListMyRegistrationOptionalParams, callback: msRest.ServiceCallback<Models.GachaRegister[]>): void;
  listMyRegistration(options?: Models.KamigamePreRegistrationApiListMyRegistrationOptionalParams | msRest.ServiceCallback<Models.GachaRegister[]>, callback?: msRest.ServiceCallback<Models.GachaRegister[]>): Promise<Models.ListMyRegistrationResponse> {
    return this.sendOperationRequest(
      {
        options
      },
      listMyRegistrationOperationSpec,
      callback) as Promise<Models.ListMyRegistrationResponse>;
  }

  /**
   * gachaId のガチャに対する自分のガチャ結果の履歴を取得します
   * @summary Your GET endpoint
   * @param gachaId
   * @param [options] The optional parameters
   * @returns Promise<Models.GetMeGachaGachaIdResultHistoryResponse>
   */
  getMeGachaGachaIdResultHistory(gachaId: string, options?: msRest.RequestOptionsBase): Promise<Models.GetMeGachaGachaIdResultHistoryResponse>;
  /**
   * @param gachaId
   * @param callback The callback
   */
  getMeGachaGachaIdResultHistory(gachaId: string, callback: msRest.ServiceCallback<Models.GachaResultHistory[]>): void;
  /**
   * @param gachaId
   * @param options The optional parameters
   * @param callback The callback
   */
  getMeGachaGachaIdResultHistory(gachaId: string, options: msRest.RequestOptionsBase, callback: msRest.ServiceCallback<Models.GachaResultHistory[]>): void;
  getMeGachaGachaIdResultHistory(gachaId: string, options?: msRest.RequestOptionsBase | msRest.ServiceCallback<Models.GachaResultHistory[]>, callback?: msRest.ServiceCallback<Models.GachaResultHistory[]>): Promise<Models.GetMeGachaGachaIdResultHistoryResponse> {
    return this.sendOperationRequest(
      {
        gachaId,
        options
      },
      getMeGachaGachaIdResultHistoryOperationSpec,
      callback) as Promise<Models.GetMeGachaGachaIdResultHistoryResponse>;
  }

  /**
   * ガチャの全ての事前登録者の一覧を取得します
   * @summary Your GET endpoint
   * @param gachaId
   * @param [options] The optional parameters
   * @returns Promise<Models.ListAllGachaRegisterPerGameResponse>
   */
  listAllGachaRegisterPerGame(gachaId: string, options?: msRest.RequestOptionsBase): Promise<Models.ListAllGachaRegisterPerGameResponse>;
  /**
   * @param gachaId
   * @param callback The callback
   */
  listAllGachaRegisterPerGame(gachaId: string, callback: msRest.ServiceCallback<Models.ListGachaRegisterResponse>): void;
  /**
   * @param gachaId
   * @param options The optional parameters
   * @param callback The callback
   */
  listAllGachaRegisterPerGame(gachaId: string, options: msRest.RequestOptionsBase, callback: msRest.ServiceCallback<Models.ListGachaRegisterResponse>): void;
  listAllGachaRegisterPerGame(gachaId: string, options?: msRest.RequestOptionsBase | msRest.ServiceCallback<Models.ListGachaRegisterResponse>, callback?: msRest.ServiceCallback<Models.ListGachaRegisterResponse>): Promise<Models.ListAllGachaRegisterPerGameResponse> {
    return this.sendOperationRequest(
      {
        gachaId,
        options
      },
      listAllGachaRegisterPerGameOperationSpec,
      callback) as Promise<Models.ListAllGachaRegisterPerGameResponse>;
  }

  /**
   * 当選者の全ての一覧を返します
   * @summary Your GET endpoint
   * @param gachaId
   * @param [options] The optional parameters
   * @returns Promise<Models.ListAllGachaWinningResponse>
   */
  listAllGachaWinning(gachaId: string, options?: msRest.RequestOptionsBase): Promise<Models.ListAllGachaWinningResponse>;
  /**
   * @param gachaId
   * @param callback The callback
   */
  listAllGachaWinning(gachaId: string, callback: msRest.ServiceCallback<Models.ListGachaWinningResponse>): void;
  /**
   * @param gachaId
   * @param options The optional parameters
   * @param callback The callback
   */
  listAllGachaWinning(gachaId: string, options: msRest.RequestOptionsBase, callback: msRest.ServiceCallback<Models.ListGachaWinningResponse>): void;
  listAllGachaWinning(gachaId: string, options?: msRest.RequestOptionsBase | msRest.ServiceCallback<Models.ListGachaWinningResponse>, callback?: msRest.ServiceCallback<Models.ListGachaWinningResponse>): Promise<Models.ListAllGachaWinningResponse> {
    return this.sendOperationRequest(
      {
        gachaId,
        options
      },
      listAllGachaWinningOperationSpec,
      callback) as Promise<Models.ListAllGachaWinningResponse>;
  }

  /**
   * 公開用のガチャを取得します
   * @summary Your GET endpoint
   * @param gachaId
   * @param [options] The optional parameters
   * @returns Promise<Models.FindPublicGachaResponse>
   */
  findPublicGacha(gachaId: string, options?: msRest.RequestOptionsBase): Promise<Models.FindPublicGachaResponse>;
  /**
   * @param gachaId
   * @param callback The callback
   */
  findPublicGacha(gachaId: string, callback: msRest.ServiceCallback<Models.PublicGacha>): void;
  /**
   * @param gachaId
   * @param options The optional parameters
   * @param callback The callback
   */
  findPublicGacha(gachaId: string, options: msRest.RequestOptionsBase, callback: msRest.ServiceCallback<Models.PublicGacha>): void;
  findPublicGacha(gachaId: string, options?: msRest.RequestOptionsBase | msRest.ServiceCallback<Models.PublicGacha>, callback?: msRest.ServiceCallback<Models.PublicGacha>): Promise<Models.FindPublicGachaResponse> {
    return this.sendOperationRequest(
      {
        gachaId,
        options
      },
      findPublicGachaOperationSpec,
      callback) as Promise<Models.FindPublicGachaResponse>;
  }

  /**
   * リリース通知のメールを送ります
   * @param gachaId
   * @param [options] The optional parameters
   * @returns Promise<msRest.RestResponse>
   */
  sendReleaseEmail(gachaId: string, options?: Models.KamigamePreRegistrationApiSendReleaseEmailOptionalParams): Promise<msRest.RestResponse>;
  /**
   * @param gachaId
   * @param callback The callback
   */
  sendReleaseEmail(gachaId: string, callback: msRest.ServiceCallback<void>): void;
  /**
   * @param gachaId
   * @param options The optional parameters
   * @param callback The callback
   */
  sendReleaseEmail(gachaId: string, options: Models.KamigamePreRegistrationApiSendReleaseEmailOptionalParams, callback: msRest.ServiceCallback<void>): void;
  sendReleaseEmail(gachaId: string, options?: Models.KamigamePreRegistrationApiSendReleaseEmailOptionalParams | msRest.ServiceCallback<void>, callback?: msRest.ServiceCallback<void>): Promise<msRest.RestResponse> {
    return this.sendOperationRequest(
      {
        gachaId,
        options
      },
      sendReleaseEmailOperationSpec,
      callback);
  }

  /**
   * ガチャに対応したアプリのダウンロードリンクに遷移します
   * @param gachaId
   * @param [options] The optional parameters
   * @returns Promise<msRest.RestResponse>
   */
  downloadApp(gachaId: string, options?: Models.KamigamePreRegistrationApiDownloadAppOptionalParams): Promise<msRest.RestResponse>;
  /**
   * @param gachaId
   * @param callback The callback
   */
  downloadApp(gachaId: string, callback: msRest.ServiceCallback<void>): void;
  /**
   * @param gachaId
   * @param options The optional parameters
   * @param callback The callback
   */
  downloadApp(gachaId: string, options: Models.KamigamePreRegistrationApiDownloadAppOptionalParams, callback: msRest.ServiceCallback<void>): void;
  downloadApp(gachaId: string, options?: Models.KamigamePreRegistrationApiDownloadAppOptionalParams | msRest.ServiceCallback<void>, callback?: msRest.ServiceCallback<void>): Promise<msRest.RestResponse> {
    return this.sendOperationRequest(
      {
        gachaId,
        options
      },
      downloadAppOperationSpec,
      callback);
  }

  /**
   * 使用されていないギフトコードの登録を解除します
   * @param gachaId
   * @param [options] The optional parameters
   * @returns Promise<Models.UnregisterGiftCodeResponse>
   */
  unregisterGiftCode(gachaId: string, options?: msRest.RequestOptionsBase): Promise<Models.UnregisterGiftCodeResponse>;
  /**
   * @param gachaId
   * @param callback The callback
   */
  unregisterGiftCode(gachaId: string, callback: msRest.ServiceCallback<Models.GiftCode[]>): void;
  /**
   * @param gachaId
   * @param options The optional parameters
   * @param callback The callback
   */
  unregisterGiftCode(gachaId: string, options: msRest.RequestOptionsBase, callback: msRest.ServiceCallback<Models.GiftCode[]>): void;
  unregisterGiftCode(gachaId: string, options?: msRest.RequestOptionsBase | msRest.ServiceCallback<Models.GiftCode[]>, callback?: msRest.ServiceCallback<Models.GiftCode[]>): Promise<Models.UnregisterGiftCodeResponse> {
    return this.sendOperationRequest(
      {
        gachaId,
        options
      },
      unregisterGiftCodeOperationSpec,
      callback) as Promise<Models.UnregisterGiftCodeResponse>;
  }

  /**
   * 事前登録者に向けてメールを送信します
   * @param gachaId
   * @param [options] The optional parameters
   * @returns Promise<Models.SendEmailResponse>
   */
  sendEmail(gachaId: string, options?: Models.KamigamePreRegistrationApiSendEmailOptionalParams): Promise<Models.SendEmailResponse>;
  /**
   * @param gachaId
   * @param callback The callback
   */
  sendEmail(gachaId: string, callback: msRest.ServiceCallback<any>): void;
  /**
   * @param gachaId
   * @param options The optional parameters
   * @param callback The callback
   */
  sendEmail(gachaId: string, options: Models.KamigamePreRegistrationApiSendEmailOptionalParams, callback: msRest.ServiceCallback<any>): void;
  sendEmail(gachaId: string, options?: Models.KamigamePreRegistrationApiSendEmailOptionalParams | msRest.ServiceCallback<any>, callback?: msRest.ServiceCallback<any>): Promise<Models.SendEmailResponse> {
    return this.sendOperationRequest(
      {
        gachaId,
        options
      },
      sendEmailOperationSpec,
      callback) as Promise<Models.SendEmailResponse>;
  }

  /**
   * 全事前登録者に向けてメールを送信します
   * @summary 全事前登録者に向けてメールを送信します
   * @param [options] The optional parameters
   * @returns Promise<Models.SendEmailToAllResponse>
   */
  sendEmailToAll(options?: Models.KamigamePreRegistrationApiSendEmailToAllOptionalParams): Promise<Models.SendEmailToAllResponse>;
  /**
   * @param callback The callback
   */
  sendEmailToAll(callback: msRest.ServiceCallback<any>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  sendEmailToAll(options: Models.KamigamePreRegistrationApiSendEmailToAllOptionalParams, callback: msRest.ServiceCallback<any>): void;
  sendEmailToAll(options?: Models.KamigamePreRegistrationApiSendEmailToAllOptionalParams | msRest.ServiceCallback<any>, callback?: msRest.ServiceCallback<any>): Promise<Models.SendEmailToAllResponse> {
    return this.sendOperationRequest(
      {
        options
      },
      sendEmailToAllOperationSpec,
      callback) as Promise<Models.SendEmailToAllResponse>;
  }

  /**
   * ガチャを引いたことのあるユーザ一覧を取得します
   * @summary Your GET endpoint
   * @param [options] The optional parameters
   * @returns Promise<Models.ListUsersWhoHavePlayedGachaResponse>
   */
  listUsersWhoHavePlayedGacha(options?: Models.KamigamePreRegistrationApiListUsersWhoHavePlayedGachaOptionalParams): Promise<Models.ListUsersWhoHavePlayedGachaResponse>;
  /**
   * @param callback The callback
   */
  listUsersWhoHavePlayedGacha(callback: msRest.ServiceCallback<Models.User[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  listUsersWhoHavePlayedGacha(options: Models.KamigamePreRegistrationApiListUsersWhoHavePlayedGachaOptionalParams, callback: msRest.ServiceCallback<Models.User[]>): void;
  listUsersWhoHavePlayedGacha(options?: Models.KamigamePreRegistrationApiListUsersWhoHavePlayedGachaOptionalParams | msRest.ServiceCallback<Models.User[]>, callback?: msRest.ServiceCallback<Models.User[]>): Promise<Models.ListUsersWhoHavePlayedGachaResponse> {
    return this.sendOperationRequest(
      {
        options
      },
      listUsersWhoHavePlayedGachaOperationSpec,
      callback) as Promise<Models.ListUsersWhoHavePlayedGachaResponse>;
  }

  /**
   * 登録情報の一覧を取得します
   * @summary Your GET endpoint
   * @param [options] The optional parameters
   * @returns Promise<Models.ListGachaRegistersResponse>
   */
  listGachaRegisters(options?: msRest.RequestOptionsBase): Promise<Models.ListGachaRegistersResponse>;
  /**
   * @param callback The callback
   */
  listGachaRegisters(callback: msRest.ServiceCallback<Models.GachaRegister[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  listGachaRegisters(options: msRest.RequestOptionsBase, callback: msRest.ServiceCallback<Models.GachaRegister[]>): void;
  listGachaRegisters(options?: msRest.RequestOptionsBase | msRest.ServiceCallback<Models.GachaRegister[]>, callback?: msRest.ServiceCallback<Models.GachaRegister[]>): Promise<Models.ListGachaRegistersResponse> {
    return this.sendOperationRequest(
      {
        options
      },
      listGachaRegistersOperationSpec,
      callback) as Promise<Models.ListGachaRegistersResponse>;
  }
}

// Operation Specifications
const serializer = new msRest.Serializer(Mappers);
const listActiveGachaOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "gacha",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Gacha"
            }
          }
        }
      }
    },
    default: {}
  },
  serializer
};

const loginOperationSpec: msRest.OperationSpec = {
  httpMethod: "POST",
  path: "login",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.LoginRequest
  },
  responses: {
    200: {
      bodyMapper: Mappers.Session
    },
    default: {}
  },
  serializer
};

const createGiftCodeBulkOperationSpec: msRest.OperationSpec = {
  httpMethod: "POST",
  path: "admin/gacha/{gachaId}/gift-code/bulk",
  urlParameters: [
    Parameters.gachaId0
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.CreateGiftCodeBulkRequest
  },
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "GiftCode"
            }
          }
        }
      }
    },
    default: {}
  },
  serializer
};

const listGiftCodeOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "admin/gacha/{gachaId}/gift-code",
  urlParameters: [
    Parameters.gachaId0
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "GiftCode"
            }
          }
        }
      }
    },
    default: {}
  },
  serializer
};

const createGachaOperationSpec: msRest.OperationSpec = {
  httpMethod: "POST",
  path: "admin/gacha",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.CreateGachaRequest
  },
  responses: {
    200: {
      bodyMapper: Mappers.Gacha
    },
    default: {}
  },
  serializer
};

const listGachaOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "admin/gacha",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Gacha"
            }
          }
        }
      }
    },
    default: {}
  },
  serializer
};

const updateGachaOperationSpec: msRest.OperationSpec = {
  httpMethod: "PUT",
  path: "admin/gacha/{gachaId}",
  urlParameters: [
    Parameters.gachaId0
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.UpdateGachaRequest
  },
  responses: {
    204: {},
    default: {}
  },
  serializer
};

const findGachaOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "admin/gacha/{gachaId}",
  urlParameters: [
    Parameters.gachaId0
  ],
  responses: {
    200: {
      bodyMapper: Mappers.Gacha
    },
    default: {}
  },
  serializer
};

const playGachaOperationSpec: msRest.OperationSpec = {
  httpMethod: "POST",
  path: "gacha/{gachaId}/play",
  urlParameters: [
    Parameters.gachaId0
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.PlayGachaRequest
  },
  responses: {
    200: {
      bodyMapper: Mappers.PlayGachaResponse
    },
    default: {}
  },
  serializer
};

const generateSmsAuthCodeOperationSpec: msRest.OperationSpec = {
  httpMethod: "POST",
  path: "me/sms-auth/generate",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.GenerateSmsAuthIdRequest
  },
  responses: {
    200: {
      bodyMapper: Mappers.GenerateSmsAuthIdResponse
    },
    default: {}
  },
  serializer
};

const verifySmsAuthCodeOperationSpec: msRest.OperationSpec = {
  httpMethod: "POST",
  path: "me/sms-auth/verify",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.VerifySmsAuthCodeRequest
  },
  responses: {
    204: {},
    default: {}
  },
  serializer
};

const updateUserOptoutOperationSpec: msRest.OperationSpec = {
  httpMethod: "PUT",
  path: "me/optout",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.UpdateUserOptoutRequest
  },
  responses: {
    204: {},
    default: {}
  },
  serializer
};

const listGachaWinningOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "admin/gacha/{gachaId}/winning",
  urlParameters: [
    Parameters.gachaId0
  ],
  queryParameters: [
    Parameters.status,
    Parameters.os,
    Parameters.offset,
    Parameters.limit,
    Parameters.isSmsAuthedUser,
    Parameters.searchWord
  ],
  responses: {
    200: {
      bodyMapper: Mappers.ListGachaWinningResponse
    },
    default: {}
  },
  serializer
};

const updateGachaWinningStatusOperationSpec: msRest.OperationSpec = {
  httpMethod: "PUT",
  path: "admin/gacha/{gachaId}/winning/{winningId}/status",
  urlParameters: [
    Parameters.gachaId0,
    Parameters.winningId
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.UpdateGachaWinningStatusRequest
  },
  responses: {
    204: {},
    default: {}
  },
  serializer
};

const getMeOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "me",
  responses: {
    200: {
      bodyMapper: Mappers.User
    },
    default: {}
  },
  serializer
};

const updateUserOptinOperationSpec: msRest.OperationSpec = {
  httpMethod: "PUT",
  path: "me/optin",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.UpdateUserOptinRequest
  },
  responses: {
    204: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Object"
        }
      }
    },
    default: {}
  },
  serializer
};

const verifyEmailAddressOperationSpec: msRest.OperationSpec = {
  httpMethod: "POST",
  path: "me/email-verified/verify",
  queryParameters: [
    Parameters.verificationID
  ],
  responses: {
    204: {},
    default: {}
  },
  serializer
};

const createEmailVerificationOperationSpec: msRest.OperationSpec = {
  httpMethod: "POST",
  path: "me/email-verified/generate",
  responses: {
    204: {},
    default: {}
  },
  serializer
};

const listGachaRegisterPerGameOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "admin/gacha/{gachaId}/register",
  urlParameters: [
    Parameters.gachaId0
  ],
  queryParameters: [
    Parameters.os,
    Parameters.offset,
    Parameters.limit,
    Parameters.searchWord
  ],
  responses: {
    200: {
      bodyMapper: Mappers.ListGachaRegisterResponse
    },
    default: {}
  },
  serializer
};

const approveGachaWinningOperationSpec: msRest.OperationSpec = {
  httpMethod: "PUT",
  path: "admin/gacha/{gachaId}/winning/approve",
  urlParameters: [
    Parameters.gachaId0
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.ApproveGachaWinningRequest
  },
  responses: {
    200: {
      bodyMapper: Mappers.ApproveGachaWinningResponse
    },
    default: {}
  },
  serializer
};

const findReleaseEmailTemplateOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "admin/gacha/{gachaId}/release-email/template",
  urlParameters: [
    Parameters.gachaId0
  ],
  responses: {
    200: {
      bodyMapper: Mappers.EmailTemplate
    },
    default: {}
  },
  serializer
};

const editReleaseEmailTemplateOperationSpec: msRest.OperationSpec = {
  httpMethod: "POST",
  path: "admin/gacha/{gachaId}/release-email/template",
  urlParameters: [
    Parameters.gachaId0
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.EditEmailTemplateRequest
  },
  responses: {
    204: {
      bodyMapper: Mappers.EmailTemplate
    },
    default: {}
  },
  serializer
};

const findRegistrationEmailTemplateOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "admin/gacha/{gachaId}/registration-email/template",
  urlParameters: [
    Parameters.gachaId0
  ],
  responses: {
    200: {
      bodyMapper: Mappers.EmailTemplate
    },
    default: {}
  },
  serializer
};

const editRegistrationEmailTemplateOperationSpec: msRest.OperationSpec = {
  httpMethod: "POST",
  path: "admin/gacha/{gachaId}/registration-email/template",
  urlParameters: [
    Parameters.gachaId0
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.EditEmailTemplateRequest
  },
  responses: {
    204: {
      bodyMapper: Mappers.EmailTemplate
    },
    default: {}
  },
  serializer
};

const listMyRegistrationOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "me/registration",
  queryParameters: [
    Parameters.gachaId1
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "GachaRegister"
            }
          }
        }
      }
    },
    default: {}
  },
  serializer
};

const getMeGachaGachaIdResultHistoryOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "me/gacha/{gachaId}/result-history",
  urlParameters: [
    Parameters.gachaId0
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "GachaResultHistory"
            }
          }
        }
      }
    },
    default: {}
  },
  serializer
};

const listAllGachaRegisterPerGameOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "admin/gacha/{gachaId}/register/all",
  urlParameters: [
    Parameters.gachaId0
  ],
  responses: {
    200: {
      bodyMapper: Mappers.ListGachaRegisterResponse
    },
    default: {}
  },
  serializer
};

const listAllGachaWinningOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "admin/gacha/{gachaId}/winning/all",
  urlParameters: [
    Parameters.gachaId0
  ],
  responses: {
    200: {
      bodyMapper: Mappers.ListGachaWinningResponse
    },
    default: {}
  },
  serializer
};

const findPublicGachaOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "gacha/{gachaId}",
  urlParameters: [
    Parameters.gachaId0
  ],
  responses: {
    200: {
      bodyMapper: Mappers.PublicGacha
    },
    default: {}
  },
  serializer
};

const sendReleaseEmailOperationSpec: msRest.OperationSpec = {
  httpMethod: "POST",
  path: "admin/gacha/{gachaId}/release-mail/send",
  urlParameters: [
    Parameters.gachaId0
  ],
  queryParameters: [
    Parameters.os
  ],
  responses: {
    204: {},
    default: {}
  },
  serializer
};

const downloadAppOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "gacha/{gachaId}/download",
  urlParameters: [
    Parameters.gachaId0
  ],
  queryParameters: [
    Parameters.os
  ],
  responses: {
    302: {},
    default: {}
  },
  serializer
};

const unregisterGiftCodeOperationSpec: msRest.OperationSpec = {
  httpMethod: "POST",
  path: "admin/gacha/{gachaId}/gift-code/unregister",
  urlParameters: [
    Parameters.gachaId0
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "GiftCode"
            }
          }
        }
      }
    },
    default: {}
  },
  serializer
};

const sendEmailOperationSpec: msRest.OperationSpec = {
  httpMethod: "POST",
  path: "admin/gacha/{gachaId}/email/send",
  urlParameters: [
    Parameters.gachaId0
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.EmailSendRequest
  },
  responses: {
    204: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Object"
        }
      }
    },
    default: {}
  },
  serializer
};

const sendEmailToAllOperationSpec: msRest.OperationSpec = {
  httpMethod: "POST",
  path: "admin/gacha/email/send",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.SendEmailToAllRequest
  },
  responses: {
    204: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Object"
        }
      }
    },
    default: {}
  },
  serializer
};

const listUsersWhoHavePlayedGachaOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "admin/user",
  queryParameters: [
    Parameters.hasPlayed
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "User"
            }
          }
        }
      }
    },
    400: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "User"
            }
          }
        }
      }
    },
    default: {}
  },
  serializer
};

const listGachaRegistersOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "admin/register",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "GachaRegister"
            }
          }
        }
      }
    },
    default: {}
  },
  serializer
};

export {
  KamigamePreRegistrationApi,
  KamigamePreRegistrationApiContext,
  Models as KamigamePreRegistrationApiModels,
  Mappers as KamigamePreRegistrationApiMappers
};
